import React, { createContext, PropsWithChildren, useMemo } from "react";

export const PagesContext = createContext<{
  cmsPages: ReadonlyArray<Queries.DirectPageFragment>;
}>({ cmsPages: [] });

export const PagesContextProvider: React.FC<
  PropsWithChildren<{
    cmsPages: ReadonlyArray<Queries.DirectPageFragment>;
  }>
> = ({ cmsPages, children }) => {
  const context = useMemo(
    () => ({
      cmsPages,
    }),
    [cmsPages],
  );
  return (
    <PagesContext.Provider value={context}>{children}</PagesContext.Provider>
  );
};
